import Login from "pages/auth/login";
import DashboardHome from "pages/dashboard/home";
import { routeConstant } from "./routeConstant";
import DashboardSettings from "pages/dashboard/settings";
import NewsletterEmails from "pages/dashboard/newsletterEmails";
import SupportMessages from "pages/dashboard/supportMessages";
import DashboardPolicies from "pages/dashboard/policies";
import DashboardBlogs from "pages/dashboard/blogs";
import DashboardTransactions from "pages/dashboard/transactions";
import DashboardSuppliers from "pages/dashboard/suppliers";
import DashboardCustomers from "pages/dashboard/customers";

const publicRoute: any = [
  {
    path: routeConstant.login.path,
    title: routeConstant.login.title,
    Component: Login,
  },
];

const privateRoute: any = [
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHome,
  },
  {
    path: routeConstant.dashboardCustomers.path,
    title: routeConstant.dashboardCustomers.title,
    Component: DashboardCustomers,
  },
  {
    path: routeConstant.dashboardSuppliers.path,
    title: routeConstant.dashboardSuppliers.title,
    Component: DashboardSuppliers,
  },
  {
    path: routeConstant.dashboardTransactions.path,
    title: routeConstant.dashboardTransactions.title,
    Component: DashboardTransactions,
  },
  {
    path: routeConstant.dashboardBlogs.path,
    title: routeConstant.dashboardBlogs.title,
    Component: DashboardBlogs,
  },
  {
    path: routeConstant.dashboardPolicies.path,
    title: routeConstant.dashboardPolicies.title,
    Component: DashboardPolicies,
  },
  {
    path: routeConstant.dashboardSupportMessages.path,
    title: routeConstant.dashboardSupportMessages.title,
    Component: SupportMessages,
  },
  {
    path: routeConstant.dashboardNewsletterEmails.path,
    title: routeConstant.dashboardNewsletterEmails.title,
    Component: NewsletterEmails,
  },
  {
    path: routeConstant.dashboardSettings.path,
    title: routeConstant.dashboardSettings.title,
    Component: DashboardSettings,
  },
];

export { privateRoute, publicRoute };
